<div class="flex h-full flex-column md:flex-row">
  <div
    class="surface-0 py-5 h-full flex flex-column gap-3 flex-grow-1 surface-border border-right-1 md:max-w-23rem w-full">
    <div class="px-4 flex flex-column gap-3">
      <div class="surface-border border-1 border-round-xl surface-0 p-4 w-max">
        <app-logo hStyleClass="h-8rem w-12rem" [logoFileName]="config?.logo" />
      </div>

      <h1 class="m-0 text-2xl mb-5 font-semibold">
        {{
          config.headline ||
            globalStore.activeCommune()?.title ||
            globalStore.activeCommune()?.name
        }}
      </h1>

      <div
        class="surface-border border-1 pl-4 pr-2 py-2 w-full md:w-20rem flex flex-column cursor-pointer hover:shadow-8 transition-all transition-duration-300 border-round"
        (click)="callSearch()">
        <header>
          <h3 class="m-0 flex align-items-center gap-3 text-l font-semibold">
            <span>Suche starten</span>
            <div
              class="bg-primary border-round-3xl ml-auto w-3rem h-3rem flex flex-shrink-0 justify-content-center align-items-center">
              <i class="fas fa-search"></i>
            </div>
          </h3>
        </header>
      </div>

      <div
        class="surface-border border-1 pl-4 pr-2 py-2 w-full md:w-20rem flex flex-column cursor-pointer hover:shadow-8 transition-all transition-duration-300 border-round"
        (click)="closeLandingPage()">
        <header>
          <h3 class="m-0 flex align-items-center gap-3 text-l font-semibold">
            <span>Erstellen</span>
            <div
              class="bg-primary border-round-3xl ml-auto w-3rem h-3rem flex flex-shrink-0 justify-content-center align-items-center">
              <i class="fas fa-screwdriver-wrench"></i>
            </div>
          </h3>
        </header>
      </div>
    </div>

    <footer class="mt-auto flex flex-column gap-3">
      <div class="px-4">
        <div class="flex gap-3">
          <p-button
            label="Indikatoren"
            styleClass="surface-border"
            [outlined]="true"
            icon="fas fa-folder-tree"
            [rounded]="true"
            (click)="showTree()"></p-button>
          <p-button
            class="ml-auto"
            styleClass="surface-border"
            [outlined]="true"
            icon="fas fa-info"
            [rounded]="true"
            (click)="showInfo()"></p-button>
          <p-button
            styleClass="surface-border"
            [outlined]="true"
            icon="fas fa-ellipsis-vertical"
            [rounded]="true"
            (onClick)="menu.toggle($event)" />
        </div>
        <p-menu #menu [model]="menuItems" [popup]="true" styleClass="w-20rem">
          <ng-template pTemplate="item" let-item>
            @if (item.url) {
              <a class="p-menuitem-link" target="_blank" [href]="item.url">
                <div class="flex align-items-center">
                  <i class="p-menuitem-icon" [class]="item.icon"></i>
                  <div>
                    <span>{{ item.label }}</span>
                    @if (item.sub) {
                      <div class="text-xs text-color-secondary mt-2">
                        {{ item.sub }}
                      </div>
                    }
                  </div>
                </div>
              </a>
            } @else {
              <a
                class="p-menuitem-link"
                [routerLink]="item.routerLink"
                [target]="item.target || '_self'">
                <div class="flex align-items-center">
                  <i class="p-menuitem-icon" [class]="item.icon"></i>
                  <div>
                    <span>{{ item.label }}</span>
                    @if (item.sub) {
                      <div class="text-xs text-color-secondary mt-2">
                        {{ item.sub }}
                      </div>
                    }
                  </div>
                </div>
              </a>
            }
          </ng-template>
        </p-menu>
      </div>

      <div class="surface-border border-top-1 pb-3"></div>
      <div class="px-4">
        <div class="flex flex-column gap-3">
          <div class="w-20rem">
            <svg
              style="width: 100%; height: auto"
              fill="rgb(12, 85, 166)"
              viewBox="0 0 260 32"
              xmlns="http://www.w3.org/2000/svg">
              <title>Bertelsmann Stiftung</title>
              <path
                d="M2.48 0v32H.5V0h1.98zm250.67 12c1.06 0 2 .23 2.78.68h3.57v1.18c0 .4-.17.6-.64.69l-1.12.22c.16.44.26.93.26 1.48 0 2.6-2.08 4.25-4.85 4.25-.48 0-.93-.05-1.37-.14-.39.25-.58.53-.58.84 0 2.1 7.99-.77 7.99 4.23 0 2.3-2.2 4.57-6 4.57-3.77 0-5.55-1.66-5.55-3.47 0-1.23.75-2.05 2-2.55-.61-.36-1-.92-1-1.88 0-.79.5-1.73 1.6-2.31a3.9 3.9 0 0 1-2.02-3.54c0-2.61 2.08-4.25 4.93-4.25zm-1.8 12.5c-.67.39-1.12.91-1.12 1.62 0 .93.82 1.63 3 1.63 2.24 0 3.2-.76 3.2-1.79 0-1.56-2.83-1.16-5.08-1.47zM22.13 7c4.48 0 6.43 1.78 6.43 4.7 0 1.77-1.12 3.34-3.42 4.04 2.65.52 4.03 1.89 4.03 4.13 0 3.06-2.33 5.13-6.4 5.13h-6.45V7h5.81zm102.51 5c2.82 0 4.37 1.93 4.37 4.76v8.04h-.97c-.44 0-.7-.09-.79-.52l-.24-1.17c-1.33 1.2-2.45 1.89-4.38 1.89-1.93 0-3.5-1.07-3.5-3.34 0-1.99 2.03-3.79 7.71-3.92v-.98c0-1.95-.84-2.97-2.47-2.97-2.15 0-2.83 1.33-3.58 1.33-.3 0-.52-.18-.66-.41l-.4-.71a6.72 6.72 0 0 1 4.91-2zM37.9 12c2.96 0 5.12 2.06 5.12 5.64 0 .7-.13.88-.53.88h-8.2c.06 3.18 1.6 4.73 3.92 4.73 2.17 0 3.08-1.22 3.63-1.22.18 0 .31.08.4.21l.62.82C41.78 24.38 39.78 25 38 25c-3.4 0-5.88-2.4-5.88-6.74 0-3.54 2.18-6.26 5.76-6.26zm154.91-.14V25h-3.09V11.86h3.1zM72.5 12c2.95 0 5.1 2.06 5.1 5.64 0 .7-.11.88-.52.88h-8.2c.06 3.18 1.6 4.73 3.92 4.73 2.17 0 3.08-1.22 3.63-1.22a.5.5 0 0 1 .41.21l.6.82C76.39 24.38 74.39 25 72.62 25c-3.4 0-5.88-2.4-5.88-6.74 0-3.54 2.18-6.26 5.76-6.26zm18.78 0a5.5 5.5 0 0 1 3.91 1.47l-.5.8a.48.48 0 0 1-.45.28c-.48 0-1.2-.9-2.91-.9-1.48 0-2.4.81-2.4 1.83 0 2.59 6.47 1.38 6.47 5.46 0 2.32-1.68 4.06-4.73 4.06a6.17 6.17 0 0 1-4.17-1.53l.52-.85c.14-.2.3-.33.6-.33.18 0 .36.1.58.25l.2.13a4 4 0 0 0 2.39.74c1.72 0 2.55-.96 2.55-2.08 0-2.77-6.5-1.33-6.5-5.67 0-1.94 1.61-3.66 4.44-3.66zm148.2 0c2.73 0 4.2 2 4.2 4.85V25h-3v-8.15c0-1.56-.7-2.45-2.12-2.45-1.03 0-1.93.5-2.75 1.34V25h-3V12.2h1.84c.39 0 .64.19.76.56l.21 1.01a5.03 5.03 0 0 1 3.85-1.77zM211.2 8v4.05h3.44v2.2h-3.44v6.98c0 .8.45 1.28 1.12 1.28.78 0 1-.43 1.32-.43.2 0 .28.09.42.27l.95 1.5a5.4 5.4 0 0 1-3.43 1.15c-2.25 0-3.53-1.34-3.53-3.56v-7.19h-1.32c-.34 0-.62-.2-.62-.65v-1.22l2.1-.34.66-3.51c.06-.34.33-.53.7-.53h1.63zm-71.74 4c2.85 0 4.37 1.95 4.37 4.85V25h-2.3v-8.15c0-1.93-.89-3.06-2.74-3.06-1.36 0-2.54.69-3.54 1.78V25h-2.3V12.2h1.38c.32 0 .52.15.62.47l.17 1.39a5.7 5.7 0 0 1 4.34-2.06zm-27.45 0c2.6 0 4.14 1.76 4.14 4.85V25h-2.18v-8.15c0-2-.87-3.06-2.48-3.06-1.43 0-2.67 1.04-2.67 3.06V25h-2.18v-8.15c0-2.06-.82-3.06-2.35-3.06-1.08 0-2 .65-2.77 1.67V25h-2.17V12.2h1.3c.3 0 .5.15.58.47l.16 1.31c.92-1.16 2-1.98 3.51-1.98 1.68 0 2.7 1.04 3.16 2.66a4.03 4.03 0 0 1 3.95-2.66zM59.95 8v4.37h3.5v1.61h-3.5v7.62c0 1.06.55 1.57 1.34 1.57.9 0 1.3-.6 1.55-.6.1 0 .21.08.3.21l.63 1.07A4.36 4.36 0 0 1 60.8 25c-1.93 0-3-1.15-3-3.25v-7.77h-1.48c-.26 0-.46-.15-.46-.48v-.9l2-.26.5-3.91a.47.47 0 0 1 .5-.43h1.09zm109.12-1a7.3 7.3 0 0 1 5.1 1.85l-.8 1.55c-.19.35-.4.49-.73.49-.66 0-1.53-1.22-3.54-1.22-1.8 0-2.71.9-2.71 2.21 0 3.34 8.1 1.55 8.1 7.4 0 3.19-2.23 5.72-6.1 5.72-2.23 0-4.4-.91-5.77-2.31l.95-1.58c.18-.23.44-.4.74-.4.81 0 1.76 1.61 4.18 1.61 1.85 0 2.92-.91 2.92-2.57 0-3.73-8.09-1.25-8.09-7.7 0-2.58 2.1-5.05 5.75-5.05zm-14.78 5c2.86 0 4.38 1.95 4.38 4.85V25h-2.3v-8.15c0-1.93-.89-3.06-2.75-3.06a4.8 4.8 0 0 0-3.53 1.78V25h-2.3V12.2h1.37c.32 0 .53.15.62.47l.18 1.39a5.7 5.7 0 0 1 4.33-2.06zM82.55 7v18h-1.98V7h1.98zM52.1 12c.72 0 1.28.17 1.78.46l-.3 1.67c-.06.22-.19.32-.4.32-.23 0-.7-.24-1.58-.24-1.6 0-2.62.93-3.34 2.66V25h-2.29V12.23h1.31c.5 0 .64.16.71.62l.15 1.99c.89-1.78 2.2-2.84 3.96-2.84zm168.89 0v8.14c0 1.55.7 2.45 2.11 2.45 1.04 0 1.94-.5 2.75-1.33V12h3v12.8h-1.83c-.39 0-.64-.19-.77-.56l-.2-1.02a5.11 5.11 0 0 1-3.86 1.78c-2.72 0-4.2-2.01-4.2-4.86V12h3zm-18.41-5a5 5 0 0 1 1.56.23l-.06 1.52c-.04.48-.48.53-1 .53-1.39 0-2.2.57-2.2 2.44v.83h3.15v2.16h-3.06V25h-2.93V14.72l-1.05-.17c-.46-.09-.76-.32-.76-.76v-1.23h1.81v-.94c0-2.87 1.73-4.62 4.54-4.62zm-20.04 1v4.05h3.44v2.2h-3.44v6.98c0 .8.45 1.28 1.12 1.28.78 0 1-.43 1.33-.43.19 0 .28.09.42.27l.94 1.5a5.4 5.4 0 0 1-3.43 1.15c-2.25 0-3.52-1.34-3.52-3.56v-7.19h-1.33c-.34 0-.62-.2-.62-.65v-1.22l2.1-.34.66-3.51c.07-.34.33-.53.7-.53h1.63zm-55.7 11.14c-4.06.14-5.6 1.04-5.6 2.42 0 1.34.91 1.89 2.05 1.89 1.52 0 2.56-.64 3.55-1.7v-2.61zM22.72 16.8h-3.93v6.27h3.94c2.81 0 4-1.35 4-3.26 0-1.86-1.32-3.01-4.01-3.01zm230.43-2.59c-1.47 0-2.2.82-2.2 2.12 0 1.24.73 2.15 2.2 2.15 1.47 0 2.2-.88 2.2-2.15 0-1.3-.74-2.11-2.2-2.11zm-215.2-.58c-2.1 0-3.3 1.31-3.6 3.5h6.7c0-2.05-1.12-3.5-3.1-3.5zm34.6 0c-2.1 0-3.3 1.31-3.6 3.5h6.71c0-2.05-1.13-3.5-3.12-3.5zm-50.42-4.7H18.8v6.13h3.25c2.79 0 4.06-1.25 4.06-3.07 0-2.11-1.26-3.07-3.97-3.07zM191.26 6a2 2 0 0 1 0 4.01 2 2 0 0 1-1.95-1.98A2 2 0 0 1 191.26 6z"></path>
            </svg>
          </div>
          <div class="flex gap-3">
            <a
              class="text-color font-semibold no-underline hover:underline text-sm"
              href="#"
              >Impressum</a
            >
            <a
              class="text-color font-semibold no-underline hover:underline text-sm"
              href="#"
              >Datenschutz</a
            >
          </div>
        </div>
      </div>
    </footer>
  </div>
  <div class="surface-ground w-full">
    <p-scrollPanel [style]="{ width: '100%', height: '100vh' }">
      <div class="flex flex-wrap p-3 w-full">
        @if (globalStore.communeConfiguration(); as config) {
          @if (checkDefaultBookmark()) {
            <div class="xl:w-8 md:w-6 w-full flex" (click)="callStartPage()">
              <div
                class="p-card m-3 p-4 flex flex-grow-1 flex-column bg-primary cursor-pointer hover:shadow-8 transition-all transition-duration-300 border-round-xl">
                <header>
                  <h3
                    class="mt-0 flex align-items-center gap-3 text-4xl font-semibold">
                    <span>Start</span>
                  </h3>
                </header>
                @if (config.startTeaser; as teaser) {
                  <div [innerHTML]="teaser"></div>
                }
                <footer class="mt-auto">
                  <p-button
                    [rounded]="true"
                    label="Startansicht laden"
                    styleClass="icon-inset"
                    icon="fas fa-arrow-right"></p-button>
                </footer>
              </div>
            </div>
          }
          @if (config.landingPageItems?.length) {
            @for (item of config.landingPageItems; track $index) {
              @if (enhancedLandingPageItem(item); as landingPageItem) {
                <div class="xl:w-4 md:w-6 w-full flex">
                  <div
                    class="p-4 p-card m-3 flex flex-grow-1 flex-column border-round-xl">
                    <header>
                      <h3
                        class="mt-0 flex align-items-center gap-3 font-semibold"
                        [ngClass]="{
                          'text-xl': landingPageItem.name.length > 20,
                          'text-2xl': landingPageItem.name.length <= 20,
                        }">
                        <span>{{ landingPageItem.name }}</span>
                        <div
                          class="bg-primary border-round-xl ml-auto w-3rem h-3rem flex flex-shrink-0 justify-content-center align-items-center text-base">
                          <i [class]="landingPageItem.icon"></i>
                        </div>
                      </h3>
                    </header>

                    @if (landingPageItem.text) {
                      <div
                        class="pb-3"
                        [innerHtml]="landingPageItem.text"></div>
                    }
                    <footer class="mt-auto">
                      <p-button
                        [rounded]="true"
                        [label]="getLabelByType(item.type)"
                        styleClass="icon-inset"
                        icon="fas fa-arrow-right"
                        (click)="landingPageItemCTA(item)"></p-button>
                    </footer>
                  </div>
                </div>
              }
            }
          } @else {}
        } @else {
          <h1 class="text-color-secondary m-3">Atlas in Zahlen</h1>
          <div class="w-full flex">
            <app-count-overview />
          </div>
        }
      </div>
    </p-scrollPanel>
  </div>
</div>

<p-dialog
  [modal]="true"
  [(visible)]="treeVisible"
  [style]="{ width: '60rem' }"
  header="Indikatoren explorieren">
  <div class="flex flex-column gap-3">
    @if (indicatorIds.length > 0) {
      <div
        class="-mx-3 p-3 surface-ground flex flex-column gap-3 sticky top-0 z-absolute-top surface-0 border-round-xl surface-border border-1">
        <div class="p-card p-3">
          <app-indicator-selection-list
            [indicatorIds]="indicatorIds"
            (unselectEvent)="
              unselectIndicator($event)
            "></app-indicator-selection-list>
        </div>
        <p-button
          [rounded]="true"
          class="ml-auto"
          label="Daten visualisieren"
          icon="fas fa-bolt"
          (click)="visualizeSelectedIndicators()"></p-button>
      </div>
    }

    <app-atlas-indicator-tree
      [combineableIndicatorIds]="combineableIndicators"
      (selectIndicator)="
        toggleIndicatorSelection($event)
      "></app-atlas-indicator-tree>
  </div>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="infoVisible" [style]="{ width: '60rem' }">
  <ng-template pTemplate="header">
    <app-header
      styleClass="m-0"
      icon="fas fa-info-circle"
      [text]="'Funktionen auf der Startseite'"></app-header>
  </ng-template>
  <p>Liebe Nutzer:innen,</p>
  <p>
    herzlich willkommen im Kommunal-Atlas – dem Online-Tool für die anschauliche
    und individuelle Auswertung kommunaler Daten.
  </p>
  <p>
    Mit dem Kommunal-Atlas können Sie Daten der Stadt, Gemeinde oder des
    Landkreises einfach und interaktiv erkunden. Ob kleinräumige Vergleiche,
    zeitliche Entwicklungen oder unterschiedliche Darstellungsformen – der Atlas
    hilft dabei, Disparitäten, Trends und Zusammenhänge schnell zu erkennen und
    schafft eine Grundlage für Diskussion, Entscheidung oder Engagement.
  </p>

  <app-header styleClass="mt-6" text="Erste Orientierung"></app-header>

  <p>
    <b>Lesen:</b> Bereits zusammengestellte Themen, Berichte und Ansichten
    (sofern vorhanden) können Sie bequem über die weißen Buttons aufrufen und
    erkunden.
  </p>
  <p>
    <b>Selbst gestalten:</b> Wenn Sie eigene Auswertungen erstellen möchten,
    nutzen Sie die beiden zentralen Funktionen: „<i class="fas fa-search"></i>
    Suche“ und „<i class="fas fa-wrench"></i> Erstellen“.
  </p>

  <app-header styleClass="mt-6" icon="fas fa-search" text="Suche"></app-header>
  <p>
    Hier können Sie nach bestimmten Indikatoren, Räumen oder Ortsteilen, Themen,
    Berichten oder Ansichten suchen. Geben Sie einfach ein Stichwort ein – der
    Kommunal-Atlas erstellt mit einem Klick automatisch eine Ansicht bestehend
    aus verschiedenen Darstellungen.
  </p>
  <p>
    Probieren Sie es aus: Wählen Sie einzelne Indikatoren per Klick auf das
    <i class="fas fa-eye"></i> oder kombinieren Sie mehrere über das
    <i class="fas fa-plus-circle"></i> – so entsteht schnell eine interaktive
    Übersicht. Indikatoren lassen sich zusätzlich filtern und über Schlagworte
    eingrenzen.
  </p>

  <app-header
    styleClass="mt-6"
    icon="fas fa-screwdriver-wrench"
    text="Erstellen"></app-header>
  <p>
    Erstellen bietet Ihnen die Möglichkeit, eigene Ansichten zu bauen. Hier
    stellen Sie sich Ihre Datenansicht individuell zusammen – z. B. mit Karten,
    Kreisdiagrammen, Liniendiagrammen oder Tabellen. Alles lässt sich flexibel
    anpassen.
  </p>

  <app-header styleClass="mt-6" icon="" text="Weiße Buttons"></app-header>

  <p>
    Die weißen Buttons auf der Seite führen Sie direkt zu den verschiedenen
    Themen, Berichten und Ansichten, welche für Sie zusammengestellt wurden. So
    finden Sie schnell, was Sie interessiert.
  </p>
  <p>
    Schauen Sie sich in Ruhe um, probieren Sie die Funktionen aus und entdecken
    Sie, was in den kommunalen Daten steckt.
  </p>
  <p>Viel Spaß beim Erkunden!</p>
</p-dialog>
